const STORAGE_KEY_PREFIX = 'questionBlocksPreference:';

// Quando o localStorage lança (modo privado, cota, etc.), a escolha do aluno cai aqui em vez
// de se perder: sem isso, marcar o checkbox como desligado e clicar "Iniciar" logo em seguida
// levava de volta ao modo blocos, já que a leitura seguinte também falhava e caía no default
// `true` — o checkbox mentia. Vale só para a aba atual (não sobrevive a um reload).
const memoryFallback = new Map<string, boolean>();

/**
 * O aluno quer ver as questões desta aula divididas em blocos?
 *
 * Lida do localStorage, por classId, para lembrar a escolha entre visitas. Sem
 * preferência salva (primeira visita, classId ausente, ou storage indisponível
 * sem nada gravado nesta aba ainda), o padrão é `true` — preserva o
 * comportamento automático que já existia antes deste toggle existir.
 */
export function getQuestionBlocksPreference(classId: number | string | undefined | null): boolean {
  if (classId === undefined || classId === null) return true;
  const key = `${STORAGE_KEY_PREFIX}${classId}`;

  try {
    const stored = localStorage.getItem(key);
    return stored === null ? true : stored === 'true';
  } catch {
    return memoryFallback.get(key) ?? true;
  }
}

export function setQuestionBlocksPreference(
  classId: number | string | undefined | null,
  enabled: boolean,
): void {
  if (classId === undefined || classId === null) return;
  const key = `${STORAGE_KEY_PREFIX}${classId}`;

  try {
    localStorage.setItem(key, String(enabled));
  } catch {
    memoryFallback.set(key, enabled);
  }
}
